import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { IUserData } from 'Types';
import { deviceSetupRedirect } from 'Utils/playAlong/playInputAccount';

/**
 * Sends a player who has not answered the device question from the roadmap to
 * the question (see deviceSetupRedirect). `ready` is true only once the
 * account record has been loaded by this run of the app: a record restored
 * from storage can be out of date (answered since), and acting on it would
 * show the question to a player who has answered. Returns true while the move
 * is pending, so the caller can hold the page behind its loading screen.
 */
export function useAskDeviceQuestionFirst(
  ready: boolean,
  userData: Partial<IUserData> | null | undefined,
): boolean {
  const location = useLocation();
  const navigate = useNavigate();
  const target = ready ? deviceSetupRedirect(location, userData) : null;
  useEffect(() => {
    if (target) navigate(target, { replace: true });
  }, [target, navigate]);
  return target !== null;
}
